import { Route, Routes } from "react-router";

import NotFoundPage from "components/error/NotFoundPage";

import FlowsProjectsList from "./ProjectsList";
import FlowsProjectDetails from "./ProjectDetails";

const Flows = () => {
  return (
    <Routes>
      <Route index element={<FlowsProjectsList />} />
      <Route path=":projectId" element={<FlowsProjectDetails />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default Flows;
